import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PoolsService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAll() {
    return this.http.get<any[]>('/api/pools/getAll');
  }

  deletePool(pool) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: { pool: pool },
    };
    return this.http.delete('/api/pools/delete', options );
  }

  save(pool) {
    return this.http.post<void>('/api/pools/createOrUpdate', pool);
  }

  getUsersByPoolUserFilter(params) {
    return this.http.post<any[]>('/api/pools/getUsersByPoolUserFilter', params);
  }

  getAllPoolMetadataValue(poolId: number) {
    return this.http.get<any[]>(`/api/pools/getAllPoolMetadataValue/${poolId}`);
  }

  getMetaflowsInfoByPoolId(poolId: number) {
    return this.http.get<any[]>(`/api/pools/getMetaflowsInfoByPoolId/${poolId}`);
  }

}
